import { makeStyles } from '@material-ui/core';
import { KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import { Schedule } from '@material-ui/icons';
import { Controller, useFormContext } from 'react-hook-form';
import { assignIn, get, isEmpty, noop } from 'lodash';
import moment from 'moment';

import NgpField from './NgpField';
import DATE_FORMATS from '../../utilities/DateTimeFormats';
import NgpFieldHelpTip from './NgpFieldHelpTip';
import { GENERIC_REQUIRED_MESSAGE } from '../../utilities/FormUtilities';
import { getMeridiemTimeFormat, useTimezone } from '../../stores/SessionStore';

const useNgpDateTimeStyles = makeStyles({
    fieldWrapper: {
        display: 'flex',
        gap: '16px',
    },
});

export default function NgpDateTime({
    fieldName,
    dateLabel,
    timeLabel,
    helpTipText,
    disabled = false,
    required = false,
    fieldRules = {},
    onChangeFunc = noop,
}) {
    const styles = useNgpDateTimeStyles();
    const { errors, control } = useFormContext();
    const rules = assignIn({}, fieldRules);
    const [tz] = useTimezone();

    if (required) {
        rules.required = GENERIC_REQUIRED_MESSAGE;
    }

    rules.validate = {
        ...fieldRules,
        validPostEpoch: (value) => {
            value = moment.isMoment(value) ? value.tz(tz) : moment.utc(value).tz(tz);

            return value.valueOf() >= 0 || 'Date must be on or after Jan 01, 1970 GMT.';
        },
    };

    return (
        <NgpField errors={errors} fieldName={fieldName}>
            <Controller
                control={control}
                name={fieldName}
                rules={rules}
                defaultValue={null}
                render={({ value, onChange }) => {
                    if (value) {
                        value = moment.isMoment(value) ? value : moment.utc(value).tz(tz);
                    }

                    return (
                        <div className={styles.fieldWrapper}>
                            <KeyboardDatePicker
                                id={`${dateLabel.toLowerCase()}-date`}
                                variant="inline"
                                label={dateLabel}
                                value={value}
                                onChange={(e) => {
                                    onChange(e);
                                    onChangeFunc(e);
                                }}
                                format={DATE_FORMATS.DATE_FIELD}
                                error={!isEmpty(get(errors, fieldName))}
                                required={required}
                                disabled={disabled}
                            />
                            <KeyboardTimePicker
                                id={`${timeLabel.toLowerCase()}-time`}
                                variant="inline"
                                label={timeLabel}
                                value={value}
                                onChange={(e) => {
                                    onChange(e);
                                    onChangeFunc(e);
                                }}
                                ampm={getMeridiemTimeFormat()}
                                error={!isEmpty(get(errors, fieldName))}
                                required={required}
                                disabled={disabled}
                                keyboardIcon={<Schedule />}
                            />
                        </div>
                    );
                }}
            />
            {helpTipText && <NgpFieldHelpTip helpText={helpTipText} />}
        </NgpField>
    );
}
